/* eslint-env browser */
import Axios from 'axios'
import * as React from 'react'

import { translateFunc } from './components/TranslatorProvider'

const ReactDOM = require('react-dom')

const request = require('axios')

const DomHelper = require('./dom-helper')
const NavbarSearch = require('./components/search/NavbarSearch')
const ScrollableCoverTabs = require('./components/ScrollableCoverTabs')
const ScrollableCoverContent = require('./components/ScrollableCoverContent')
const SideCardsContainer = require('./components/SideCards/Container')

const Initiator = require('./scripts/init')

const doTranslate = (key, opts = {}) => {
  const locale = window.initialState.locale.identifierShort
  return translateFunc(key, { locale, ...opts })
}

window.onFBInitCallback = function() {}

window.logout = function() {
  try {
    window.FB.logout()
  } catch (e) {
    console.error('Error while logging out from FB: ', e)
  }
  request.get('/api/logout').then(function() {
    window.location = '/'
  })
}

window.onFacebookLogin = function(data, isForRegister) {
  if (!data || data.status !== 'connected') {
    return
  }
  if (isForRegister) {
    window.fbq('track', 'CompleteRegistration')
  }
  const res = data.authResponse
  if (res.accessToken && res.accessToken.length > 0 && res.userID && res.userID.length > 0) {
    request
      .post(
        '/api/loginFacebook',
        {
          access_token: res.accessToken,
          id: res.userID,
          expiration_date: res.expiresIn,
        },
        {
          params: {
            sendPecheurPromoCodeWhenRegistering: window.sendPecheurPromoCodeWhenRegistering === 'true',
            sendPecheurPromoCodeWhenRegisteringProductArticleId:
              window.sendPecheurPromoCodeWhenRegisteringProductArticleId,
          },
        }
      )
      .then(() => {
        if (window.location.pathname === '/') {
          window.location = '/me/feed'
        } else {
          window.location.reload(true)
        }
      })
      .catch(err => {
        if (err.response && err.response.data === 'existing_email') {
          window.alert(doTranslate('login.facebookError.existingEmail'))
          return
        }
        window.alert(doTranslate('login.facebookError.unknown'))
      })
  }
}

window.loginWithFacebook = function(e) {
  if (e) {
    e.preventDefault()
  }

  if (!window.FB) {
    console.error('FaceBook does not exists')
    return
  }
  window.FB.login(
    function(response) {
      // handle the response
      window.onFacebookLogin(response)
    },
    {
      scope: 'public_profile,email,user_friends',
      return_scopes: true,
    }
  )
}

window.onFacebookRegister = function(data) {
  return window.onFacebookLogin(data, true)
}

let appbarElementCache
const handleScroll = function() {
  const scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0
  const appBar = appbarElementCache || DomHelper.query('#app-bar.is-transparent-on-scroll-zero')
  if (appBar) {
    appbarElementCache = appBar
    if (scrollTop > 60) {
      DomHelper.removeClass(appBar, 'is-transparent')
    } else {
      DomHelper.addClass(appBar, 'is-transparent')
    }
  }
}

const addReactComponent = ({ into, getComponent, hydrate }) => {
  const destination = DomHelper.query(into)
  if (destination) {
    if (hydrate) {
      ReactDOM.hydrate(getComponent(), destination)
    } else {
      ReactDOM.render(getComponent(), destination)
    }
  }
}

DomHelper.onDocumentReady(() => {
  // init everything that needs to be initiated
  Initiator.modals()
  Initiator.header()
  Initiator.images()
  Initiator.incentives()
  Initiator.horizontalScroll()

  if (DomHelper.query('#app-bar.is-transparent-on-scroll-zero')) {
    window.addEventListener('scroll', handleScroll)
    handleScroll({
      srcElement: {
        body: {
          scrollTop: document.body.scrollTop,
        },
      },
    })
  }

  // components
  addReactComponent({
    into: '#react-render-navbar-searchbar',
    getComponent: () => <NavbarSearch locale={window.initialState.locale.identifierShort} />,
  })
  addReactComponent({
    into: '#react-render-scrollable-cover-tabs',
    getComponent: () => (
      <ScrollableCoverTabs
        tabs={window.initialState.scrollableCoverTabs}
        title={window.initialState.scrollableCoverTabsTitle}
      />
    ),
    hydrate: true,
  })
  addReactComponent({
    into: '#react-render-scrollable-cover-content',
    getComponent: () => (
      <ScrollableCoverContent tabs={window.initialState.scrollableCoverTabs} appConfig={window.initialState} />
    ),
    hydrate: true,
  })
  addReactComponent({
    into: '#react-render-side-cards-container',
    getComponent: () => (
      <SideCardsContainer
        locale={window.initialState.locale.identifierShort}
        sideCards={window.initialState.sideCards}
        appConfig={window.initialState}
      />
    ),
    hydrate: true,
  })

  Initiator.ads()

  Axios.get('/api/signInWithApple/signInFromWeb/csrfToken').then(response => {
    const { data } = response
    const { csrfToken } = data
    window.AppleID.auth.init({
      clientId: window.initialState.signInWithAppleConfig.clientId,
      scope: 'email name',
      redirectURI: window.initialState.signInWithAppleConfig.redirectURI,
      state: csrfToken,
      nonce: csrfToken,
      usePopup: false,
    })
  })

  try {
    console.log('%c##############################', 'background: white; color: blue; font-size: large;')
    console.log('%cHELLO THERE FELLOW DEVELOPER !', 'background: white; color: blue;')
    console.log('%cWHAT ARE YOU DOING HERE? LOOKING HOW FISHFRIENDER IS MADE?', 'background: white; color: blue;')
    console.log('%cMAYBE WE SHOULD CHAT? GO TO https://fishfriender.welcomekit.co/', 'background: white; color: blue;')
    console.log('%c##############################', 'background: white; color: red;')
    console.log('%cOR MAYBE ARE YOU TRYING TO GET SOME DATA FROM OUR WEBSITE?', 'background: white; color: red;')
    console.log(
      '%c ⚠️  PLEASE REMEMBER THAT ACCORDING TO OUR DATA POLICY, AND UNLESS YOU HAVE WRITTEN CONSENT FROM US, ALL DATA HERE ARE THE SOLE PROPERTY OF FishFriender OR USERS OF THE PLATFORM.',
      'background: white; color: red;'
    )
    console.log(
      '%c ⚠️  If you want to do something (cool we hope) with some data you find on our website, please contact us to see how we could work together: contact@fishfriender.com',
      'background: white; color: red;'
    )
  } catch (e) {}
})

if (module.hot) {
  module.hot.accept()
}
